<!-- TEMPLATE -->
<template>
  <span class="header-span">
    <dean-header
            v-if="$store.getters.isAuthenticated"
            :data="header"
            :logo="theme.data.headerLogo"
            @mobile-menu-state="mobileMenuState"
            :searchBar="true"
            logo-height="35">
      <span slot="dean-header-search">
        <search></search>
      </span>
        <!-- PRIMARY -->
      <span slot="dean-header-items-primary" v-show="$store.getters.isAuthenticated">
        <span>
          <span v-for="item in header.general">
            <fade-transition v-if="item.children == null">
              <dean-header-item
                      @dean-header-item-click="deanHeaderMenuRoute(item)"
                      :id="item.name"
                      :key="item.title"
                      :icon="item.icon"
                      :state="item.state">
                {{ item.title }}
              </dean-header-item>
            </fade-transition>
            <fade-transition v-else>
              <dean-header-item-dropdown
                      :id="item.name"
                      :key="item.title"
                      :text="item.title"
                      :icon="item.icon"
                      :state="item.state"
                      grid>
                <dean-header-item
                        @dean-header-item-click="deanHeaderMenuRoute(dropdownItem)"
                        v-for="dropdownItem in item.children"
                        :id="dropdownItem.name"
                        :key="dropdownItem.title"
                        :icon="dropdownItem.icon"
                        :state="dropdownItem.state">
                  {{ dropdownItem.title }}
                </dean-header-item>
              </dean-header-item-dropdown>
            </fade-transition>
          </span>
        </span>
      </span>
      <span slot="dean-header-items-secondary" class="row" v-show="$store.getters.isAuthenticated">
        <dean-header-item-dropdown
            :text="'Menu'"
            :icon="burgerIcon"
            grid
            class="small-0 medium-6 large-0 hd-0">
           <dean-header-item
               @dean-header-item-click="deanHeaderMenuRoute(item)"
               v-for="item in header.general"
               :key="item.title"
               :icon="item.icon"
               :state="item.state">
           {{ item.title }}
           </dean-header-item>
        </dean-header-item-dropdown>
        <dean-header-item-dropdown
                :text="user.name"
                :icon="profileIcon"
                grid
                class="small-12 medium-6 large-12 hd-12">
            <dean-header-item @dean-header-item-click="deanHeaderMenuRoute({name: 'profile.myAccount'})"
                              :key="'account'"
                              :icon="userIcon"
                              grid>
              Mijn account
            </dean-header-item>
            <dean-header-item @dean-header-item-click="deanHeaderMenuRoute({name: 'profile.users'})"
                            :key="'users'"
                            :icon="usersIcon"
                            grid>
              Gebruikers
            </dean-header-item>
            <dean-header-item @dean-header-item-click="deanHeaderMenuRoute({name: 'profile.contacts'})"
                              :key="'contacts'"
                              :icon="usersIcon"
                              grid>
              Contacten
            </dean-header-item>
            <dean-header-item @dean-header-item-click="deanHeaderMenuRoute({name: 'profile.myOrganization'})"
                              :key="'organization'"
                              :icon="businessIcon"
                              grid>
              Mijn organisatie
            </dean-header-item>
            <dean-header-item @dean-header-item-click="changePassword"
                              :key="'password'"
                              :icon="lockIcon"
                              grid>
              Wachtwoord wijzigen
            </dean-header-item>
            <dean-header-item
                    @dean-header-item-click="$router.push({name:'auth.admin'})"
                    v-if="user.privileges.includes('view-auth')"
                    :key="'auth'"
                    :icon="logoutIcon"
                    grid>
              Naar authorisatie
            </dean-header-item>
            <dean-header-item
              @dean-header-item-click="support()"
              :icon="supportIcon"
              grid>
              Support
            </dean-header-item>
            <dean-header-item
                    @dean-header-item-click="logout()"
                    :key="'uitloggen'"
                    :icon="logoutIcon"
                    grid>
              Uitloggen
            </dean-header-item>
        </dean-header-item-dropdown>
      </span>
      <span slot="dean-header-items-mobile">
        <div class="row">
           <dean-section-divider>Menu</dean-section-divider>
           <dean-header-item
                   @dean-header-item-click="deanHeaderMenuRoute(item)"
                   v-for="item in header.general"
                   :key="item.title"
                   :icon="item.icon"
                   :state="item.state">
           {{ item.title }}
           </dean-header-item>
        </div>
      </span>
    </dean-header>
  </span>
</template>

<!-- SCRIPT -->
<script lang="ts">
  // VUE
  import Vue from 'vue';
  import {Component, Prop, Watch} from 'vue-property-decorator';
  import Search from '@/components/Search.vue';
  import {FadeTransition, ZoomYTransition} from 'vue2-transitions';

  // DEAN COMPONENTS
  import {
    // COMPONENTS
    deanIcon,
    dashboardIcon,
    invoicesIcon,
    devicesIcon,
    logoutIcon,
    profileIcon,
    burgerIcon,
    helpIcon,
    userIcon,
    usersIcon,
    businessIcon,
    deanOneviewLogo,
    lockIcon,
    deanHeader,
    deanHeaderItem,
    deanHeaderItemDropdown,
    deanHeaderProfile,
    deanHeaderSearch,
    deanSectionDivider,
  } from '@deanone/dean-components';
  import {deanDialogBus} from '@/main';
  import {redirectToKeycloak} from '@/services/keycloak';

  @Component({
    components: {
      deanIcon,
      dashboardIcon,
      invoicesIcon,
      devicesIcon,
      logoutIcon,
      profileIcon,
      burgerIcon,
      helpIcon,
      deanOneviewLogo,
      deanHeader,
      deanHeaderItem,
      deanHeaderItemDropdown,
      deanHeaderProfile,
      deanHeaderSearch,
      deanSectionDivider,
      Search,
      FadeTransition,
      ZoomYTransition,
    },
  })

  export default class HeaderMenu extends Vue {

    public profileIcon: object = profileIcon;
    public burgerIcon: object = burgerIcon;
    public logoutIcon: object = logoutIcon;
    public userIcon: object = userIcon;
    public usersIcon: object = usersIcon;
    public businessIcon: object = businessIcon;
    public lockIcon: object = lockIcon;
    public supportIcon: object = helpIcon;
    public dev: boolean = process.env.NODE_ENV !== 'production';

    public src: string = '...';
    public data: any = {};
    public limit: number = 10;
    public minChars: number = 3;

    get header() {
      return this.$store.getters.getHeader;
    }

    get theme() {
      return this.$store.getters.getTheme;
    }

    get user() {
      return this.$store.getters.getUser;
    }

    public mobileMenuState: boolean = false;

    // METHODS
    public deanHeaderMenuRoute(item: any) {
      // resetting meta data when switching between main routes
      this.$store.dispatch('resetMeta');

      if (item.url && item.url.includes('http')) {
        window.open(item.url);
      } else {
        this.$router.push({name: item.name});
        this.$store.dispatch('requestHeader');
      }
    }

    public logout() {
      deanDialogBus.$emit('open', 'Logout');
    }

    public support() {
      window.open('https://support.gammacommunications.nl/hc/nl', '_blank');
    }

    public goto(route: string) {
      window.open(route, '_blank');
    }

    public changePassword() {
      // Account Console access is blocked (403/404) for non-admin users, so redirect
      // straight to Keycloak's password update action instead, with email prefilled.
      redirectToKeycloak(this.user.email, false, 'UPDATE_PASSWORD');
    }

    public created() {
      // tslint:disable-next-line:no-console
      console.log(process.env);
    }
  }
</script>


<style lang="scss" scoped>
.dean-header {
  background-color: red;

  :deep(.dean-header-menu) {
    .row {
      overflow: visible;

      .columns {
        overflow: visible;
      }
    }

    @media screen and (min-width: 869px) and (max-width: 1365px) {
      .dean-header-menu-items {
        .dean-header-menu-items-group {
          span {
            height: 90%;
          }
        }
      }
    }

    .dean-header-item-dropdown .dean-header-item-dropdown-content-grid {
      margin-left: -180px !important;
    }

    .dean-header-item-dropdown-content {
      display: grid;
      grid-template-columns: repeat(3, 3fr);

      .dean-header-item {
        word-wrap: break-word;
        word-break: break-all;

        p {
          white-space: normal;
          text-overflow: clip;
          word-break: normal;
        }
      }
    }
  }
}
</style>
